// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "checkout__checkoutNarrow-21icx";
var _4 = "paymentForm__wrapper-3Rt8X";
var _5 = "iframe-bvb1U";
var _6 = "cards_header-35DWX";
export { _1 as "__esModule", _2 as "tablet", _3 as "checkout__checkoutNarrow", _4 as "paymentForm__wrapper", _5 as "iframe", _6 as "cards_header" }
export default { "__esModule": _1, "tablet": _2, "checkout__checkoutNarrow": _3, "paymentForm__wrapper": _4, "iframe": _5, "cards_header": _6 }
